// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* errorStyles.css - Estilos para campos com erro de validação */

/* Estilo para inputs com erro */
.input-error input,
.input-error textarea,
.input-error select {
  border: 2px solid #ef4444 !important;
  background-color: #fef2f2 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
}

.input-error input:focus,
.input-error textarea:focus,
.input-error select:focus {
  border-color: #dc2626 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.2) !important;
  outline: none;
}

/* Estilo para labels de campos com erro */
.input-error label {
  color: #ef4444 !important;
  font-weight: 600;
}

/* Animação de shake para chamar atenção */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

.input-error {
  animation: shake 0.5s ease-in-out;
}

/* Estilo para seção de radio buttons com erro */
.section-error {
  border: 2px solid #ef4444 !important;
  border-radius: 8px;
  padding: 12px;
  background-color: #fef2f2;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
  animation: shake 0.5s ease-in-out;
}

.section-error label {
  color: #ef4444 !important;
}

/* Ícone de erro ao lado do campo */
.input-error::after {
  content: "⚠️";
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
}

/* Mensagem de erro abaixo do campo */
.input-error-message {
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}

.input-error-message::before {
  content: "⚠️";
  font-size: 14px;
}

/* Estilo para campos válidos após correção */
.input-valid input,
.input-valid textarea,
.input-valid select {
  border: 2px solid #10b981 !important;
  background-color: #f0fdf4 !important;
}

.input-valid label {
  color: #10b981 !important;
}

/* Header de seção com erro */
.divisor h2 {
  position: relative;
}

.section-error + h2::before,
.divisor:has(.section-error) h2::before {
  content: "⚠️ ";
  color: #ef4444;
  margin-right: 8px;
}

/* Tooltip de erro para radio buttons */
.section-error::before {
  content: "Selecione uma opção";
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ef4444;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.section-error::after {
  content: "";
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #ef4444;
  z-index: 10;
}

/* Responsivo */
@media (max-width: 768px) {
  .input-error input,
  .input-error textarea,
  .input-error select {
    font-size: 14px;
  }
  
  .section-error::before {
    font-size: 11px;
    padding: 4px 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Cadastro/Produtos/FormProduto/ModalPizza/Body/errorStyles.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE,gCAAgC;AAChC;;;EAGE,oCAAoC;EACpC,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;;;EAGE,gCAAgC;EAChC,uDAAuD;EACvD,aAAa;AACf;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,WAAW,wBAAwB,EAAE;EACrC,0BAA0B,2BAA2B,EAAE;EACvD,qBAAqB,0BAA0B,EAAE;AACnD;;AAEA;EACE,iCAAiC;AACnC;;AAEA,gDAAgD;AAChD;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;;;EAGE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,WAAW;AACb;;AAEA,eAAe;AACf;EACE;;;IAGE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* errorStyles.css - Estilos para campos com erro de validação */\n\n/* Estilo para inputs com erro */\n.input-error input,\n.input-error textarea,\n.input-error select {\n  border: 2px solid #ef4444 !important;\n  background-color: #fef2f2 !important;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;\n}\n\n.input-error input:focus,\n.input-error textarea:focus,\n.input-error select:focus {\n  border-color: #dc2626 !important;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.2) !important;\n  outline: none;\n}\n\n/* Estilo para labels de campos com erro */\n.input-error label {\n  color: #ef4444 !important;\n  font-weight: 600;\n}\n\n/* Animação de shake para chamar atenção */\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }\n  20%, 40%, 60%, 80% { transform: translateX(5px); }\n}\n\n.input-error {\n  animation: shake 0.5s ease-in-out;\n}\n\n/* Estilo para seção de radio buttons com erro */\n.section-error {\n  border: 2px solid #ef4444 !important;\n  border-radius: 8px;\n  padding: 12px;\n  background-color: #fef2f2;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n  animation: shake 0.5s ease-in-out;\n}\n\n.section-error label {\n  color: #ef4444 !important;\n}\n\n/* Ícone de erro ao lado do campo */\n.input-error::after {\n  content: \"⚠️\";\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 18px;\n}\n\n/* Mensagem de erro abaixo do campo */\n.input-error-message {\n  color: #ef4444;\n  font-size: 12px;\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 500;\n}\n\n.input-error-message::before {\n  content: \"⚠️\";\n  font-size: 14px;\n}\n\n/* Estilo para campos válidos após correção */\n.input-valid input,\n.input-valid textarea,\n.input-valid select {\n  border: 2px solid #10b981 !important;\n  background-color: #f0fdf4 !important;\n}\n\n.input-valid label {\n  color: #10b981 !important;\n}\n\n/* Header de seção com erro */\n.divisor h2 {\n  position: relative;\n}\n\n.section-error + h2::before,\n.divisor:has(.section-error) h2::before {\n  content: \"⚠️ \";\n  color: #ef4444;\n  margin-right: 8px;\n}\n\n/* Tooltip de erro para radio buttons */\n.section-error::before {\n  content: \"Selecione uma opção\";\n  position: absolute;\n  top: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #ef4444;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n}\n\n.section-error::after {\n  content: \"\";\n  position: absolute;\n  top: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #ef4444;\n  z-index: 10;\n}\n\n/* Responsivo */\n@media (max-width: 768px) {\n  .input-error input,\n  .input-error textarea,\n  .input-error select {\n    font-size: 14px;\n  }\n  \n  .section-error::before {\n    font-size: 11px;\n    padding: 4px 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
